import { NotificationsModule } from "@/store/modules/notification.module";
import { Machine, assign } from "xstate";
const notificationMachine = Machine({
    id: "notification",
    context: {
        skipCount: 0,
        isNew: true,
        filterType: "All",
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "gettingNotifications",
            },
        },
        gettingNotifications: {
            invoke: {
                id: "gettingNotifications",
                src: (context, event) => NotificationsModule.GetNotificationDetails({ skipCount: context.skipCount, filterType: context.filterType, isNew: context.isNew }),
                onDone: { target: "notificationLoaded", actions: "isNew" },
                onError: { target: "notificationLoaded" },
            },
        },
        notificationLoaded: {
            on: {
                UN_SEEN: { target: "gettingNotifications", actions: "changeFilterType" },
                REQUEST_TRACKING: { target: "gettingNotifications", actions: "changeFilterType" },
                LOAD_MORE: { target: "notificationLoading" },
                MARK_ALL_AS_SEEN: { target: "markAllAsSeen" },
                ALL: { target: "gettingNotifications", actions: "changeFilterType" },
            },
        },
        notificationLoading: {
            invoke: {
                id: "gettingNotifications",
                src: (context, event) => NotificationsModule.GetNotificationDetails({ skipCount: context.skipCount, filterType: context.filterType, isNew: context.isNew }),
                onDone: { target: "notificationLoaded" },
                onError: { target: "notificationLoaded" },
            },
        },
        markAllAsSeen: {
            tags: "markAllAsSeen",
            invoke: {
                id: "markAllAsSeen",
                src: (context, event) => NotificationsModule.UpdateAllNotificationRead(),
                onDone: { target: "gettingNotifications", actions: "clearUnread" },
                onError: { target: "notificationLoaded" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        changeFilterType: assign({
            filterType: (context, event) => event.filterType,
        }),
        clearUnread: assign({
            filterType: (context, event) => {
                if (context.filterType === "UnSeen" || "RequestTracking") {
                    NotificationsModule.ClearNotification();
                }
                return context.filterType;
            },
        }),
        isNew: assign({
            isNew: (context, event) => false,
        }),
    },
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 2000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default notificationMachine;
